import { gameConfigurationStore } from '../gameModule/store/gameConfigurationStore';

export function mousePositionToIconColumnRow(element, mouseEvent) {
  const { tx, ty } = element.worldTransform;

  const inputPos = mouseEvent.data.getLocalPosition(element.parent);

  const {
    visibleRows,
    iconsFinalPositions: { inWinContainer },
    iconsHeight,
    iconsWidth,
  } = gameConfigurationStore.reelsParams[0];

  const visibleRowCenters = inWinContainer
    .slice(visibleRows, visibleRows + 4)
    .map(({ yInWin }) => yInWin);

  const columnPositions = gameConfigurationStore.reelsParams.map(({ finalPositionX }) => finalPositionX);
  const halfIconWidth = iconsWidth / 2;
  const halfIconHeight = iconsHeight / 2;

  // const scale = Math.min(
  //   window.innerWidth / (isMobile() ? 540 : 1440),
  //   window.innerHeight / (isMobile() ? 960 : 810)
  // );
  const containerX = inputPos.x - tx;
  const containerY = inputPos.y - ty;

  const column = columnPositions.findIndex((xPos, index, arr) => {
    if (index < arr.length - 1) {
      return containerX >= xPos && containerX < arr[index + 1] - gameConfigurationStore.reelsParams[index].spacing;
    }
    return containerX >= xPos && containerX < xPos + halfIconWidth * 2;
  });

  const row = visibleRowCenters.findIndex(
    (centerY) => containerY >= centerY - halfIconHeight && containerY <= centerY + halfIconHeight
  );

  return { column, row };
}
